import React, { useState, useEffect } from 'react';
import firebase from 'firebase';
import { db } from './firebase/firebase';
import "./css/Home.css"

function Resources() {
    var unSub=()=>{}
  
    const [datas, setDatas] =useState([]);
    const [ResourceData, setResourceData] = useState([])
    useEffect(() => {
        getData();
      return ()=>{
        unSub();
      }
    },[])
  
    const getData = ()=>{
      unSub= db.collection("resource").onSnapshot(function (querySnapshot) {
          setResourceData(
                querySnapshot.docs.map((doc) =>({
                    name: doc.data().name,
                    Location: doc.data().location,
                    Number: doc.data().phoneNumber,
                    Resource: doc.data().Resource
                }))
            );
            setDatas(querySnapshot.docs.map((doc) =>({
              name: doc.data().name,
              Location: doc.data().location,
              Number: doc.data().phoneNumber,
              Resource: doc.data().Resource
          })));
        })
     
    }
    const [searchData, setsearchData] = useState("")
    var handleChnage=value=>{
        setsearchData(value);
        filterResource(value);
  
    }

    const filterResource=value=>{
      const lowerCaseValue=value.toLowerCase().trim();
      if (!lowerCaseValue) {
        setResourceData(datas);
      } else {
        const filterData=datas.filter(item=>{
          return Object.keys(item).some(key=>{
          return item[key].toString().toLowerCase().includes(lowerCaseValue);
          // console.log(item[key]); 
          })
        
        });
        setResourceData(filterData);
      }
    }

    return (
        <>
         <div className="container d-flex justify-content-center">
                <div className="container dash-cont mt-3 p-5 container-r">
                <p className="mb-1">DashBoard</p>
                    <h4 className="text-white">Thank You For Helping</h4>
                     <div className="form-group mt-3">
                     <label htmlFor="exampleInputPassword1" style={{color:"white"}}>Enter Location To Search</label>
<input type="text" className="form-control form-area-input " id="exampleInputPassword1" placeholder="Search Your Area" value={searchData || ""} onChange={e=>handleChnage(e.target.value)} />
</div>     
     
                     {/* <div className="form-group">
<input type="text" className="form-control form-area-input w-50" id="exampleInputPassword1" placeholder="Search For Resource"  />
</div>      */}
     
            </div>
                
            </div>
   
   
         <table class="table table-sm table-sticky-header my-4 mx-auto">
  <thead class="thead text-center">
    <tr>
    <th scope="col">Resource</th>
      <th scope="col">Name</th>
      <th scope="col">Address</th>
      <th scope="col">Phone</th>
    </tr>
  </thead>
  <tbody className="bg-light text-center">
  {ResourceData.map((data,index) =>{
    return (
      <>
      <tr key={index}>
        <td>{data.Resource}</td>
        <td>{data.name}</td>
        <td>{data.Location}</td>
        <td>{data.Number}</td>
      </tr>
      </>
    )
  })} 
  </tbody>
</table>

        </>
    )
}

export default Resources;
